// Figma: 9783:44354 — see stories/blocks/waybuddy-embed.stories.tsx
"use client";

import { useEffect, useRef, useState } from "react";

/**
 * Renders the WayBuddy iframe only once the placeholder enters the viewport.
 *
 * Mounting the iframe immediately causes WayBuddy's React app to call
 * focus() on its input, which makes the browser scroll the parent page to
 * bring the iframe into view — causing the Commercial tab to jump past
 * Meet the Team on click.
 *
 * Fix: use IntersectionObserver to hold a same-height placeholder in place
 * of the iframe until the section enters the viewport (rootMargin: 200px).
 * By the time the user scrolls there the iframe mounts and any focus-scroll
 * is a no-op.
 */
export function WayBuddyEmbed() {
  const placeholderRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = placeholderRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry?.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: "200px" }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={placeholderRef} style={{ minHeight: 700 }}>
      {isVisible && (
        <iframe
          src="https://waybuddy.lovable.app/embed"
          width="100%"
          height="700"
          title="WayBuddy Chat"
          // eslint-disable-next-line react/iframe-missing-sandbox -- WayBuddy requires scripts and same-origin for the canonical embed.
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
          style={{
            border: "none",
            borderRadius: "16px",
            boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
          }}
        />
      )}
    </div>
  );
}
